import { render, staticRenderFns } from "./comboboxstore.vue?vue&type=template&id=70fcb514&"
import script from "./comboboxstore.vue?vue&type=script&lang=js&"
export * from "./comboboxstore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports